import { CancellationEndpoint } from '@acorn-portal/shared/src/pages/cancellation/types';
import { stepsInOrder } from '../../constants';

/**
 * Validate the page URL against the current step ceiling for the cancellations journey.
 * @param url The URL to validate
 * @param stepCeiling The current step ceiling

 */
export const validateStepIndex = (urlSuffix: CancellationEndpoint, stepCeiling: CancellationEndpoint | undefined) => {
	if (!stepCeiling) return false;
	// Review urlSuffix against protected endpoints
	const protectedIndex = stepsInOrder.indexOf(urlSuffix);
	if (protectedIndex === -1) return false;
	// Next decide if the url is before or after the permitted step ceiling
	const ceilingIndex = stepsInOrder.indexOf(stepCeiling);

	return protectedIndex <= ceilingIndex;
};
